import { render, staticRenderFns } from "./NewHiddenIcon.vue?vue&type=template&id=80a344fc&scoped=true"
import script from "./NewHiddenIcon.vue?vue&type=script&lang=js"
export * from "./NewHiddenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a344fc",
  null
  
)

export default component.exports